import React from 'react'
import styles from "../TaxlistTemplate/TaxlistTemplate.module.css"
import { Link } from "react-router-dom"
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import DeleteIcon from '@mui/icons-material/Delete';
export default function UserTemplate({ userlist, userDelete }) {
    return (
        <>
            {userlist.map((item, index) => (
                <div className={styles.taxlistTemplatemain} key={item.id ?? index}>
                    <div className={styles.taxlistTemplateDesc}>
                        <p><span>{item.name}</span></p>
                        <p><span>{item.email}</span></p>
                        <p><span>{item.contact_no}</span></p>
                        {item.status ? <button className={styles.success}>Active</button> : <button className={styles.danger}>Deactive</button>}
                    </div>

                    <div className={styles.taxlistTemplateedit}>
                        <Link to={`/updateuser/${item?.id}`} className={styles.iconBtn}>
                            <EditNoteRoundedIcon style={{ color: "#4c2fb3", fontSize: 18 }} titleAccess="Update" />
                        </Link>
                        <span className={styles.iconBtn} onClick={() => userDelete(item.id)}>
                            <DeleteIcon style={{ color: "#EF4444", fontSize: 18 }} titleAccess="Delete" />
                        </span>
                    </div>
                </div>
            ))}
        </>
    )
}
